__turbopack_context__.v({
  "left-picture": "LeftPicture-module-scss-module__g3H_Gq__left-picture",
  "left-picture-edit": "LeftPicture-module-scss-module__g3H_Gq__left-picture-edit",
  "left-picture-img": "LeftPicture-module-scss-module__g3H_Gq__left-picture-img",
  "left-picture-overlay": "LeftPicture-module-scss-module__g3H_Gq__left-picture-overlay",
});
